import { z } from 'zod';

export const challengeTypeSchema = z.enum([
  'TOTP',
  'EMAIL_TOTP',
  'SMS_TOTP',
  'BACKUP_TOKEN',
  'Z_TOKEN',
  // Also accept lowercase versions
  'totp',
  'email_totp',
  'sms_totp',
  'backup_token',
  'z_token',
  // Also accept variations
  'AUTHENTICATOR_TOTP',
  'authenticator_totp',
]);

export type ChallengeType = z.infer<typeof challengeTypeSchema>;

export const challengeItemSchema = z.object({
  status: z.string(),
  type: z.string(),
});

export type ChallengeItem = z.infer<typeof challengeItemSchema>;

export const challengeDataSchema = z.object({
  id: z.string(),
  expires_at: z.string(),
  token: z.string(),
  user_id: z.string(),
  challenges: z.array(challengeItemSchema),
});

export const challengeResponseSchema = z.object({
  type: z.literal('challenge'),
  data: challengeDataSchema,
});

export type ChallengeData = z.infer<typeof challengeDataSchema>;
export type ChallengeResponse = z.infer<typeof challengeResponseSchema>;

export const challengeVerifyRequestSchema = z.object({
  challenge_token: z.string(),
  challenge_type: challengeTypeSchema,
  code: z.string(),
});

export type ChallengeVerifyRequest = z.infer<typeof challengeVerifyRequestSchema>;

// Helper to normalize challenge type to uppercase
export function normalizeChallengeType(type: string): ChallengeType {
  const upper = type.toUpperCase();
  if (upper === 'AUTHENTICATOR_TOTP') return 'TOTP';
  return upper as ChallengeType;
}
